import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'shortNumber',
})
export class shortNumber implements PipeTransform {
  transform(
    number: number,
    prefix: string,
    display: boolean,
    digitsInfo: string,
    locale: string
  ): any {
    prefix = prefix || ''
    if (isNaN(number)) return number
    if (number === null) return number
    if (number === 0) return prefix + String(number)
    let abs = Math.abs(number)
    const rounder = Math.pow(10, 1)
    const isNegative = number < 0
    let key = ''

    const powers = [
      { key: 'Q', value: Math.pow(10, 15) },
      { key: 'T', value: Math.pow(10, 12) },
      { key: 'B', value: Math.pow(10, 9) },
      { key: 'M', value: Math.pow(10, 6) },
      { key: 'K', value: 1000 },
    ]

    for (let i = 0; i < powers.length; i++) {
      let reduced = abs / powers[i].value
      reduced = Math.round(reduced * rounder) / rounder
      if (reduced >= 1) {
        abs = reduced
        key = powers[i].key
        break
      }
    }
    return prefix + (isNegative ? '-' : '') + abs + key
  }
}
